// extracted by mini-css-extract-plugin
module.exports = {"excert":"MakerHubRelatedArticle_excert__TbQ9d","image":"MakerHubRelatedArticle_image__2L_1P"};